import { GroundLoyaltyMap } from "redmond";
import { strictAlphanumericRegex, loyaltyPattern } from "./hotelLoyaltyutils";

export interface IGroundLoyalty {
  key: string;
  value: string;
  trackingId: number;
  error: boolean;
}

export type IGroundLoyaltyList = IGroundLoyalty[];

export const getGroundLoyaltyList = (
  groundLoyaltyMap: GroundLoyaltyMap
): IGroundLoyaltyList =>
  Object.entries(groundLoyaltyMap).map((groundLoyalty, index) => ({
    key: groundLoyalty[0],
    value: groundLoyalty[1].value,
    trackingId: index,
    error: !(
      strictAlphanumericRegex.test(groundLoyalty[0]) &&
      loyaltyPattern.test(groundLoyalty[1].value)
    ),
  }));

export const getGroundLoyaltyMap = (
  groundLoyaltyList: IGroundLoyaltyList
): GroundLoyaltyMap => {
  const groundLoyaltyMap: GroundLoyaltyMap = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const groundLoyalty of groundLoyaltyList) {
    groundLoyaltyMap[groundLoyalty.key] = {
      value: groundLoyalty.value,
    };
  }

  return groundLoyaltyMap;
};
